
import rules from "../../mixins/rules.mixin.js";

export default {
  name: "contactsForm",

  mixins: [rules],

  computed: {
    contacts: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("change", val);
      },
    },
  },

  watch: {
    isCelphoneWhatsapp(val) {
      if (val) {
        this.contacts.whatsapp = this.contacts.celular;
      } else {
        this.contacts.whatsapp = "";
      }
    },

    "contacts.celular"() {
      if (this.isCelphoneWhatsapp) {
        this.contacts.whatsapp = this.contacts.celular;
      }
    },
  },

  data: () => ({
    isCelphoneWhatsapp: false,
    rules: {
      required: (v) => !!v || "Campo obrigatório.",
      email: (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
    },
  }),

  props: {
    value: Object,
  },
};
